const cartButton = document.querySelector('[data-tab-cart]');
const menuButton = document.querySelector('[data-tab-menu]');
const countNode = document.querySelector('[data-tab-count]');

const setCount = (count) => {
  if (!countNode) return;
  const value = Number(count) || 0;
  countNode.textContent = value > 99 ? '99+' : String(value);
  countNode.classList.toggle('hidden', value === 0);
};

cartButton?.addEventListener('click', () => {
  document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
});

menuButton?.addEventListener('click', () => {
  document.querySelector('.header__icon--menu')?.click();
});

document.addEventListener('shopify:cart:lines-update', (event) => {
  event.promise
    ?.then(({ cart, detail }) => {
      setCount(cart?.totalQuantity ?? detail?.itemCount ?? 0);
    })
    .catch(() => {});
});
